/**
 * Round number to specified decimal numbers. default: 2
 * round(1.005) === 1.01
 * @param value number to round
 * @param decimals decimal places
 */
export function round(value: number, decimals: number = 2) {
  // @ts-ignore
  return +(Math.round(value + 'e+' + decimals) + 'e-' + decimals);
}

export function stringToNumber(val: string | number) {
  return typeof val === 'string' ? parseInt(val) : val;
}
